import { atom, useResetRecoilState } from "recoil";
import { useHistory } from "react-router-dom";
import { PUBLIC_ROUTE } from "../routes/routes.constants";
import {message} from "antd";
import useAxios from "../api/api";

export const accessTokenState = atom({
  key: "accessTokenState",
  default: "",
});

export const refreshTokenState = atom({
  key: "refreshTokenState",
  default: "",
});

//로그아웃 함수
export const useLogout = () => {
  const history = useHistory();
  const api = useAxios();

  const resetAccessToken = useResetRecoilState(accessTokenState);
  const resetRefreshToken = useResetRecoilState(refreshTokenState);

  return () => {
    const data = api.post("/admin/logout");

    resetAccessToken();
    resetRefreshToken();
    localStorage.clear();
    history.push(PUBLIC_ROUTE.LOGIN);
    window.location.reload();
  };
};
